/* eslint-disable @typescript-eslint/no-require-imports */
import type { PressableProps } from "$src/core/components/atoms/Pressable/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<PressableProps>>({
  web: () => require("./Pressable.web").default,
  tv: () => require("./Pressable.tv").default,
  default: () => require("./Pressable").default,
})();
